import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/eye': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 144c0.1 0 0.2 0 0.3 0 61.7 0 111.7 50 111.7 111.7 0 61.7-50 111.7-111.7 111.7s-111.7-50-111.7-111.7c0-8.7 2-22.6 4.4-31 6.9 3.9 19 7.2 27 7.2 30.9 0 56-25.1 56-56-0.1-8-3.3-20.1-7.2-27 8.4-2.6 22.4-4.9 31.2-5zM572.5 241.4c1.9 3.8 3.5 10.3 3.5 14.6s-1.6 10.8-3.5 14.6c-54.2 105.8-161.6 177.4-284.5 177.4s-230.3-71.6-284.5-177.4c-1.9-3.8-3.5-10.3-3.5-14.6s1.6-10.8 3.5-14.6c54.2-105.8 161.6-177.4 284.5-177.4s230.3 71.6 284.5 177.4zM288 400c98.7 0 189.1-55 237.9-144-48.8-89-139.3-144-237.9-144s-189.1 55-237.9 144c48.8 89 139.3 144 237.9 144z'
      }
    ]
  }
})
